
import { useTranslation } from "react-i18next";
import styles from "./PartSurveyItemReport.module.scss";
import { useState } from "react";

import checkicon from 'assets/icons/check.png'
import circleicon from 'assets/icons/circle.png'
import squareicon from 'assets/icons/square.png'
import checksquareicon from 'assets/icons/square_check.png'
import pieeeeechart from 'assets/icons/pieeeeechart.png'
import Notification from "utils/Notifications";
import { PieChart } from 'react-minimal-pie-chart'
import { removeDefendant, moveDefendantUp, moveDefendantDown } from "service/SurveyService";
import { EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

const PartSurveyItemReport = ({ item, index, setRender, MassLength, ChangeRowOn }) => {
    const { t } = useTranslation("common");

    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });

    const generateUniqueColor = (usedColors) => {
        let color;
        do {
            color = `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`;
        } while (color === "#ffffff" || usedColors.has(color)); 
        usedColors.add(color);
        return color;
    };

    const usedColors = new Set();
    const DraftContent = ({ draftData }) => {
        let contentState;
        try {
            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            contentState = convertFromRaw(parsedData);

            if (!parsedData?.blocks[0]?.text) {
                return null

            }
        } catch (error) {
            return <p>Invalid content format</p>;
        }

        const editorState = EditorState.createWithContent(contentState);

        return (
            <div st>
                <Editor editorState={editorState} readOnly toolbarHidden />
            </div>
        );
    };

    const pieChartData = item.defendant_part_survey
        .filter(defendant => defendant.times_selected_percent !== 0) 
        .map(defendant => ({
            id_chipolino: defendant.id,
            title: <DraftContent draftData={defendant.title} />,
            value: defendant.times_selected_percent,
            text: `${defendant.times_selected_percent} (${defendant.times_selected})`,
            color: generateUniqueColor(usedColors),
        }));


    const [text, setText] = useState('');
    const maxLength = 1000;  

    const handleChange = (event) => {
        setText(event.target.value);
    };

    const [file, setFile] = useState(null);

    const handleFileChange_test = (e) => {
        setFile(e.target.files[0]);
    };

    return (

        <div className={styles.defendant_card_selection}>
            <div className={styles.defendant_card_selection_header}>


               
            </div>
            {item.image &&
                <img
                    src={item.image}
                    className={styles.img_file}
                />
            }
            <div className={styles.defendant_card_selection_body}>

                <DraftContent draftData={item.body} />
                <div className={styles.defendant_card_selection_leeRATE}>
                    <div className={styles.defendant_card_selection_body_defendant}>
                        {item.defendant_part_survey.map((defendant, index) => (
                            <div style={{ width: '100%' }}>
                                {(item.type_defendant !== "freeTextDefendant" && item.type_defendant !== "numericInput" && item.type_defendant !== "textInput" && item.type_defendant !== "infoText" && item.type_defendant !== 'fileUpload') ? (
                                    <div className={styles.defendant_card_header}>

                                       
                                        {(item.type_defendant === 'sequenceOrdering') &&
                                            <>
                                                <DraftContent draftData={defendant.title} />
                                                <select
                                                    className={styles.point_check_num_text}
                                                    value={defendant.sequences_selectedNumber}  

                                                >
                                                    <option value={defendant.sequences_selectedNumber}>{defendant.sequences_selectedNumber}</option>
                                                </select>
                                            </>
                                        }
                                        {(item.type_defendant === 'slider') &&
                                            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: "5px" }}>
                                                <div>
                                                    <h4 >{defendant.type_input_txt}</h4>

                                                </div>
                                                <div className={styles.slider_min_max}>
                                                    <h4>{Math.min(Number(defendant.min_len), Number(defendant.max_len))}</h4>
                                                    <input
                                                        id="slider"
                                                        type="range"
                                                        min={Math.min(Number(defendant.min_len), Number(defendant.max_len))}
                                                        max={Math.max(Number(defendant.min_len), Number(defendant.max_len))}
                                                        value={defendant.rdefendant}
                                                        style={{ width: '100%' }}
                                                    />
                                                    <h4>{Math.max(Number(defendant.min_len), Number(defendant.max_len))}</h4>
                                                    <h4 className={styles.slider_right_defendant}> <img
                                                        src={checksquareicon}
                                                        className={styles.img}
                                                    />{defendant.rdefendant}</h4>
                                                </div>
                                            </div>
                                        }
                                   
                                        {(item.type_defendant === 'singleSelection' || item.type_defendant === 'multipleSelection') &&
                                            <div style={{ borderBottom: "1px solid #1100d2" }}><DraftContent draftData={defendant.title} />     <span className={styles.chart_info} ><div
                                                style={{
                                                    width: '20px',
                                                    height: '20px',
                                                    backgroundColor: pieChartData.find(data => data.id_chipolino === defendant.id)?.color, 
                                                    marginRight: '8px',
                                                    borderRadius: '5px',
                                                }}
                                              
                                            ></div>{defendant.times_selected_percent}% ({defendant.times_selected}) {t('surveys.report.answer_chosen')}</span> </div>
                                        }
                                    </div>
                                ) : (
                                    <>
                                        {(item.type_defendant === "freeTextDefendant" || item.type_defendant !== "numericInput" || item.type_defendant !== "textInput" ) && (
                                            <div className={styles.defendant_card_header}>
                                                <div className={styles.defendant_card_second_div} >
                                                  {t('surveys.report.free_format_answer')}
                                                </div>
                                            </div>

                                        )}
                                        {item.type_defendant === "fileUpload" && (
                                            <div className={styles.defendant_card_header}>
                                                <div className={styles.defendant_card_second_div} >
                                                {t('surveys.report.free_format_answer')}
                                                </div>
                                            </div>
                                        )}

                                    </>
                                )}
                                {defendant.file &&
                                    <img
                                        src={defendant.file}
                                        className={styles.img_file}
                                    />
                                }
                            </div>
                        ))}
                    </div>
                    <div className={styles.defendant_card_selection_leeRATE2}>
                        {(item.type_defendant === 'singleSelection' || item.type_defendant === 'multipleSelection') &&
                            <div className={styles.pie_size}>
                                <PieChart
                                    animate
                                    animationDuration={1000}
                                    animationEasing="ease-in"
                                    center={[50, 50]}
                                    data={pieChartData}
                                    lengthAngle={360}
                                    lineWidth={40}
                                    paddingAngle={3}
                                    radius={50}
                                    startAngle={0}
                                    label={({ dataEntry }) => ` ${dataEntry.value}%`}
                                    labelPosition={77}
                                    labelStyle={{
                                        fontSize: '8px',
                                        fontColor: 'FFFFFА',
                                        fontWeight: '800',
                                        lineHeight: '1em',
                                    }}
                                    className={styles.defendant_card_selection_leeRATE2_chart}

                                />
                            </div>
                        }
                    </div>
                </div>
                {item?.comment !== null &&
                    <div style={{ marginTop: '40px', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>


                        <DraftContent draftData={item.comment} />

                    </div>
                }

            </div>

            <hr></hr>
            <Notification notify={notify} setNotify={setNotify} />
        </div >


    );
};

export default PartSurveyItemReport;
